import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReceipts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/receipts/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceipt(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/receipts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editReceipt(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/receipts", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceipt(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/receipts", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/invoices/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // updateReceiptItem(ctx, data) {
    //   return new Promise((resolve, reject) => {
    //     axiosIns
    //       .post("/receipts/salary", data)
    //       .then((response) => resolve(response))
    //       .catch((error) => reject(error));
    //   });
    // },
    deleteReceiptItem(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/receipts/item", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateReceiptDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/receipts/document", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceiptDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/receipts/document", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCustomerInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/customers/${id}/invoices`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 獲取下一個收據編號
    getNextReceiptNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/receipts/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證收據編號唯一性
    validateReceiptNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/receipts/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 檢查付款階段是否已存在
    checkPaymentStepExists(ctx, data) {
      return new Promise((resolve, reject) => {
        // 確保參數結構正確
        const params = {
          invoice_id: data.invoice_id,
          payment_step_id: data.payment_step_id,
          exclude_receipt_id: data.exclude_receipt_id || null
        };

        axiosIns
          .post("/finance/receipts/check-payment-step", params)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  }
};
